import { connect } from 'react-redux'

const mapStateToProps = (state) => ({
  positions: state.positions,
})

export default connect(mapStateToProps)



// WEBPACK FOOTER //
// ./src/components/PositionsScene/PositionsList/positionsListContainer.js